module.exports = __webpack_public_path__ + "img/perCapital.193514e9.png";